const ONES = [
  '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
  'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
  'Seventeen', 'Eighteen', 'Nineteen',
];
const TENS = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

function twoDigits(n: number): string {
  if (n < 20) return ONES[n];
  return TENS[Math.floor(n / 10)] + (n % 10 !== 0 ? ` ${ONES[n % 10]}` : '');
}

function numberToWordsIndian(n: number): string {
  if (n === 0) return 'Zero';
  const parts: string[] = [];
  let rem = n;
  if (rem >= 10000000) {
    parts.push(`${twoDigits(Math.floor(rem / 10000000))} Crore`);
    rem %= 10000000;
  }
  if (rem >= 100000) {
    parts.push(`${twoDigits(Math.floor(rem / 100000))} Lakh`);
    rem %= 100000;
  }
  if (rem >= 1000) {
    parts.push(`${twoDigits(Math.floor(rem / 1000))} Thousand`);
    rem %= 1000;
  }
  if (rem >= 100) {
    parts.push(`${ONES[Math.floor(rem / 100)]} Hundred`);
    rem %= 100;
  }
  if (rem > 0) {
    if (parts.length > 0) parts.push('And');
    parts.push(twoDigits(rem));
  }
  return parts.join(' ').replace(' And And ', ' And ');
}

/** e.g. 5250 → "Indian Rupee Five Thousand Two Hundred Fifty Only" */
export function amountInWordsINR(amount: number): string {
  const rupees = Math.floor(Number(amount) || 0);
  const paise = Math.round(((Number(amount) || 0) - rupees) * 100);
  let result = `Indian Rupee ${numberToWordsIndian(rupees)}`;
  if (paise > 0) {
    result += ` And ${numberToWordsIndian(paise)} Paise`;
  }
  return `${result} Only`;
}
